import React, {Component} from 'react';
import style from "./layout.module.scss";
import classNames from 'classnames';

export default class Col extends Component {

	render() {
		let props = Object.assign({}, this.props);
		props.className = classNames(style.col, props.className);

		return (
			<div {...props}>
				{this.props.children}
			</div>
		);
	}
}